import { Controller } from "@hotwired/stimulus"

// One-slide-at-a-time carousel for the landing page.
//
// <div data-controller="landing-carousel">
//   <div data-landing-carousel-target="track"> <figure data-landing-carousel-target="slide">… </div>
//   <button data-action="landing-carousel#prev"> <button data-action="landing-carousel#next">
//   <span data-landing-carousel-target="counter">
//
// Wraps around at both ends, supports swipe on touch screens and the arrow
// keys when focused, and slides the other way in right-to-left layouts. The
// track takes the height of the slide shown, so a shorter image does not sit
// on the blank space left for the tallest one.
export default class extends Controller {
  static targets = ["track", "slide", "counter"]

  connect() {
    this.index = 0
    this.onPointerDown = (e) => { this.startX = e.clientX }
    this.onPointerUp = (e) => {
      if (this.startX == null) return
      const dx = e.clientX - this.startX
      this.startX = null
      if (Math.abs(dx) < 40) return
      const forward = this.isRtl ? dx > 0 : dx < 0
      forward ? this.next() : this.prev()
    }
    this.trackTarget.addEventListener("pointerdown", this.onPointerDown)
    this.trackTarget.addEventListener("pointerup", this.onPointerUp)

    // Heights are only known once images load, and change with the width.
    this.fitHeight = () => this.fitTrackHeight()
    window.addEventListener("resize", this.fitHeight)
    this.element.querySelectorAll("img").forEach((img) => img.addEventListener("load", this.fitHeight))
    this.render()
  }

  disconnect() {
    this.trackTarget.removeEventListener("pointerdown", this.onPointerDown)
    this.trackTarget.removeEventListener("pointerup", this.onPointerUp)
    window.removeEventListener("resize", this.fitHeight)
    this.element.querySelectorAll("img").forEach((img) => img.removeEventListener("load", this.fitHeight))
  }

  next() {
    this.index = (this.index + 1) % this.slideTargets.length
    this.render()
  }

  prev() {
    this.index = (this.index - 1 + this.slideTargets.length) % this.slideTargets.length
    this.render()
  }

  get isRtl() {
    return getComputedStyle(this.element).direction === "rtl"
  }

  render() {
    const offset = this.index * 100 * (this.isRtl ? 1 : -1)
    this.trackTarget.style.transform = `translateX(${offset}%)`
    this.slideTargets.forEach((slide, i) => slide.setAttribute("aria-hidden", i === this.index ? "false" : "true"))
    if (this.hasCounterTarget) this.counterTarget.textContent = this.index + 1
    this.fitTrackHeight()
  }

  fitTrackHeight() {
    const slide = this.slideTargets[this.index]
    if (slide) this.trackTarget.style.height = `${slide.offsetHeight}px`
  }
}
